import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'
import { MoveResourceForm } from './common/MoveResourceForm/MoveResourceForm'

import { useMoveResourceModalState } from './hooks'

import styles from './MoveResourceModal.module.scss'

export const MoveResourceModal = ({
  alert,
  className = undefined,
  position,
  title,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state, handlers } = useMoveResourceModalState(
    { position },
    { onCancel, onClose, onConfirm },
  )

  const {
    form: { control, formState },
    hasInterviewModule,
    isConfirmationOpen,
  } = state

  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
  } = handlers

  return (
    <React.Fragment>
      <Modal
        className={cx(styles.modal, className)}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Save`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ title, isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <MessageAlert
            className={styles.alert}
            message={alert}
            variant="warning"
            isInitialised
          />
          <MoveResourceForm {...{ control, formState, hasInterviewModule }} />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </React.Fragment>
  )
}
